import React from "react";
// import Scrollbar from "react-smooth-scrollbar";
// import logo from "./logo.svg";
import "./css/style.css";
// import Logo from "./components/Logo";
// import FancyFont from "./components/FancyFont";
import { Smoke } from "./components/Smoke";
import { Header } from "./components/Header";
import { Content } from "./components/Content";
import { Footer } from "./components/Footer";
import { isIOS } from "react-device-detect";
import castle from "./assets/img/castle.png";
// import { Characters } from "./components/Characters";
// import { Contest } from "./components/Contest";
// import { Story } from "./components/Story";
import track from "./components/Track";
import Close from "@material-ui/icons/Menu";

function App() {
  const [brightness, setBrightness] = React.useState(3);
  const [iH, setIH] = React.useState(window.innerHeight);
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    // window.scrollTo({ top: 0, behavior: "smooth" });
    window.addEventListener("scroll", () => setIH(window.scrollY));
  }, []);
  return (
    <>
      {isIOS ? (
        <div
          id="ios"
          style={{ position: "fixed", width: "100%", height: "100vh" }}
        >
          <img src={castle} alt="" width="100%" />
        </div>
      ) : (
        <Smoke b={brightness} clouds={10} />
      )}
      <Nav show={show} setShow={setShow} track={track} />
      <Header show={show} setShow={setShow} />

      {/* <Contest /> */}
      {/* <Story /> */}
      {/* <Characters /> */}
      <Content />

      <Footer />
    </>
  );
}

export default App;

const Nav = ({ show, setShow, track }) => {
  const [burger, setBurger] = React.useState(false);
  return (
    <nav
      style={{
        width: "100%",
        height: "initial",
        backgroundColor: "transparent",
        position: "fixed",
        zIndex: 2,
        pointerEvents: "none",
      }}
      className={"flex row start"}
    >
      {/* large nav */}
      <div className="hide-on-small">
        <div className="flex row">
          <a href="https://fallenlegiongame.com/">
            <button
              style={{
                backgroundColor: "white",
                color: "black",
                fontSize: "1rem",
              }}
            >
              More Fallen Legion
            </button>
          </a>
          <button
            style={{
              // backgroundColor: "white",
              // color: "black",
              fontSize: "1rem",
            }}
            onClick={() => {
              // track("preorder");
              setShow(true);
            }}
          >
            BUY NOW
          </button>
          <div
            className="nav-btn"
            onClick={() =>
              document
                .getElementById("story")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Story
          </div>
          <div
            className="nav-btn"
            onClick={() =>
              document
                .getElementById("characters")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Characters
          </div>
          <div
            className="nav-btn"
            onClick={() =>
              document
                .getElementById("exemplars")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Exemplars
          </div>
          <div
            className="nav-btn"
            onClick={() =>
              document
                .getElementById("trailers")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Trailers
          </div>
          <div
            className="nav-btn"
            onClick={() =>
              document
                .getElementById("screenshots")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Screenshots
          </div>
          <div
            className="nav-btn"
            onClick={() =>
              document
                .getElementById("wallpapers")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Wallpapers
          </div>
          {/* <div
            className="nav-btn"
            onClick={() =>
              document
                .getElementById("dlc")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            DLC
          </div> */}
        </div>
      </div>
      <div className="hide-on-big">
        <div
          className="btn"
          style={{
            margin: "8px",
            fontSize: "1rem",
            position: "fixed",
            pointerEvents: "initial",
            zIndex: 3,
            border: 0,
            top: 0,
            left: 0,
            backgroundColor: "initial",
          }}
          onClick={() => {
            setBurger(!burger);
          }}
        >
          <Close style={{ color: "white", fontSize: "2rem" }} />
        </div>
        <div
          className="flex burger"
          style={{
            transform: `translateX(${burger ? 0 : "-200%"})`,
            transition: `.7s ease`,
          }}
        >
          <a href="https://fallenlegiongame.com/">
            <button
              onClick={() => setBurger(false)}
              style={{
                backgroundColor: "white",
                color: "black",
                fontSize: "1rem",
              }}
            >
              More Fallen Legion
            </button>
          </a>
          <button
            style={{
              // backgroundColor: "white",
              // color: "black",
              fontSize: "1rem",
            }}
            onClick={() => {
              setBurger(false);
              // track("preorder");
              setShow(true);
            }}
          >
            BUY NOW
          </button>
          <div
            className="nav-btn"
            onClick={() => {
              setBurger(false);
              document
                .getElementById("story")
                .scrollIntoView({ behavior: "smooth" });
            }}
          >
            Story
          </div>
          <div
            className="nav-btn"
            onClick={() => {
              setBurger(false);
              document
                .getElementById("characters")
                .scrollIntoView({ behavior: "smooth" });
            }}
          >
            Characters
          </div>
          <div
            className="nav-btn"
            onClick={() => {
              setBurger(false);
              document
                .getElementById("exemplars")
                .scrollIntoView({ behavior: "smooth" });
            }}
          >
            Exemplars
          </div>
          <div
            className="nav-btn"
            onClick={() => {
              setBurger(false);
              document
                .getElementById("trailers")
                .scrollIntoView({ behavior: "smooth" });
            }}
          >
            Trailers
          </div>
          <div
            className="nav-btn"
            onClick={() => {
              setBurger(false);
              document
                .getElementById("screenshots")
                .scrollIntoView({ behavior: "smooth" });
            }}
          >
            Screenshots
          </div>
          <div
            className="nav-btn"
            onClick={() => {
              setBurger(false);
              document
                .getElementById("wallpapers")
                .scrollIntoView({ behavior: "smooth" });
            }}
          >
            Wallpapers
          </div>
          {/* <div
            className="nav-btn"
            onClick={() => {
              setBurger(false);
              document
                .getElementById("dlc")
                .scrollIntoView({ behavior: "smooth" });
            }}
          >
            DLC
          </div> */}
        </div>
      </div>
    </nav>
  );
};
